export default function getUsername() {
  return window.auth.profile.username;
}
